import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const userLogin = createAsyncThunk("userLogin", async (data) => {
  try {
    const response = await AxiosInstance.post(`${API_KEY}/api/user/login`, data, {
      "Content-Type": "application/json",
    });

    return response;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  userLoginData: null,
  isError: false,
  errorMessage: "",
};
const userLoginSlice = createSlice({
  name: "userLogin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userLogin.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(userLogin.fulfilled, (state, action) => {
      state.isLoading = false;
      state.userLoginData = action.payload;
    });
    builder.addCase(userLogin.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default userLoginSlice.reducer;
